import {
  DEMO_OPEN_AI_FAILURE,
  DEMO_OPEN_AI_REQUEST,
  DEMO_OPEN_AI_SUCCESS,
} from "../types/openAI/demo";
import { postOpenAiApi } from "./api";

export const fetchDemoOpenAiRequest = () => ({
  type: DEMO_OPEN_AI_REQUEST,
});

export const fetchDemoOpenAiSuccess = (data) => ({
  type: DEMO_OPEN_AI_SUCCESS,
  data,
});

export const fetchDemoOpenAiFailure = (error) => ({
  type: DEMO_OPEN_AI_FAILURE,
  error,
});

export const fetchDemoOpenAi =
  (botContent = "", inputText = "hi") =>
  (dispatch) => {
    const formData = {
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "system",
          content: botContent,
        },
        {
          role: "user",
          content:
            inputText.length > 5
              ? `${inputText}, provide long answer`
              : `${inputText}`,
        },
      ],
    };
    const chatGpt = {
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "user",
          content: `${inputText}`,
        },
      ],
    };
    dispatch(fetchDemoOpenAiRequest());
    return postOpenAiApi(
      `https://api.openai.com/v1/chat/completions`,
      botContent.includes("GPT-4") ? chatGpt : formData
    )
      .then((data) => {
        dispatch(fetchDemoOpenAiSuccess(data));
        if (data) {
          return data.data.choices[0].message.content;
        }
      })
      .catch((error) => {
        console.log("error", error);
        dispatch(fetchDemoOpenAiFailure(error));
      });
  };
